import { styled } from "@mui/material/styles";

const _ScrollView = (props) => <div {...props} />;

export const ScrollView = styled(_ScrollView)(() => {
  return {
    "&::-webkit-scrollbar": {
      width: 4,
      backgroundColor: "#F6F7F8",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: 4,
      backgroundColor: "#C9CCD0",
    },
  };
});
